import Vue from 'vue';

import PhotoswipeContainer from 'components/photoswipe/PhotoswipeContainer';
import PhotoswipeItem from 'components/photoswipe/PhotoswipeItem';

Vue.component('photoswipe-container', PhotoswipeContainer);
Vue.component('photoswipe-item', PhotoswipeItem);
